<template>
    <Card :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`" :newLayout="
    true" :hideHeader="false" :hideFooter="false">
        <template slot="card-header">
            <h1 v-translate>Complete Enrolment</h1>
        </template>
        <template slot="card-body">
            <form ref="form" method="POST" :action="$laraRoute('password.set')" @submit.prevent="handleForm" aria-label="Set Password" novalidate>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="salutation"
                        class="col-md-3"
                        v-translate
                    >Title</label>

                    <div
                        class="col-md-6"
                        v-if="Object.keys(allowedSalutations).length"
                    >
                        <div
                            class="tabs"
                            :class="{ 'tabs-invalid': errors.has('salutation'), 'tabs-disabled': formSubmitting }"
                        >
                            <template v-for="(val, key, ind) in allowedSalutations">
                                <input
                                    v-if="ind === 0"
                                    v-validate="'radioTabs'"
                                    data-vv-validate-on="change"
                                    :key="`input${ind}`"
                                    :id="`salutation_${key}`"
                                    type="radio"
                                    class="form-control"
                                    name="salutation"
                                    :disabled="formSubmitting ? true : false"
                                    required
                                    v-model="user.salutation"
                                    :value="key"
                                >
                                <input
                                    v-else
                                    data-vv-validate-on="change"
                                    :key="`input${ind}`"
                                    :id="`salutation_${key}`"
                                    type="radio"
                                    class="form-control"
                                    name="salutation"
                                    :disabled="formSubmitting ? true : false"
                                    required
                                    v-model="user.salutation"
                                    :value="key"
                                >
                                <label
                                    :key="`label${ind}`"
                                    class="tab text-capitalize"
                                    :for="`salutation_${key}`"
                                >{{ val }}</label>
                            </template>
                        </div>
                        <InlineError
                            :errors="errors"
                            type="salutation"
                        />
                    </div>
                    <div
                        class="col-md-6 loader loader--inline"
                        v-else
                    >
                        <loader />
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="experience"
                        class="col-md-3"
                        v-translate
                    >Trading Experience</label>
                    <div class="col-md-6">
                        <div
                            class="tabs"
                            :class="{ 'tabs-invalid': errors.has('experience'), 'tabs-disabled': formSubmitting }"
                        >
                            <input
                                v-model="user.experience"
                                v-validate="'radioTabs'"
                                data-vv-validate-on="change"
                                id="experience_nonprof"
                                type="radio"
                                class="form-control"
                                name="experience"
                                :disabled="formSubmitting ? true : false"
                                required
                                value="Non-Professional"
                            >
                            <label
                                class="tab"
                                for="experience_nonprof"
                                v-translate
                            >Non Professional</label>
                            <input
                                v-model="user.experience"
                                v-validate="'radioTabs'"
                                data-vv-validate-on="change"
                                id="experience_prof"
                                type="radio"
                                class="form-control"
                                name="experience"
                                :disabled="formSubmitting ? true : false"
                                required
                                value="Professional"
                            >
                            <label
                                class="tab"
                                for="experience_prof"
                                v-translate
                            >Professional</label>
                        </div>
                        <InlineError
                            :errors="errors"
                            type="experience"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }"
                >
                    <div class="col-md-3">
                        <label
                            for="first_name"
                            v-translate
                        >First Name</label>
                    </div>
                    <div class="col-md-6">
                        <Input
                            id="first_name"
                            name="first_name"
                            :rule="{
                                rules: {
                                    required: user.first_name
                                        ? false
                                        : true
                                }
                            }"
                            model="user.first_name"
                            module="Enrolment"
                            :maxlength="100"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }"
                >
                    <div class="col-md-3">
                        <label
                            for="first_name"
                            v-translate
                        >Last Name</label>
                    </div>
                    <div class="col-md-6">
                        <Input
                            id="last_name"
                            name="last_name"
                            :rule="{
                                rules: {
                                    required: user.last_name
                                        ? false
                                        : true
                                }
                            }"
                            model="user.last_name"
                            module="Enrolment"
                            :maxlength="100"
                        />
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start row">
                    <label
                        for="dob-day"
                        class="col-md-3"
                        v-translate
                    >Date of Birth</label>
                    <DOBPicker
                        :dobHandler="dobHandler"
                        :months="months"
                        :days="days"
                        :user="user"
                        :day="day"
                        :month="month"
                        :year="year"
                        :wrapperClass="'col-md-6'"
                    />
                </div>
                <div class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }">
                    <label
                        for="country"
                        class="col-md-3"
                        v-translate
                    >Country</label>

                    <div
                        class="col-md-6"
                        v-if="countries.length"
                    >
                        <CountrySelect
                            :required="true"
                            :options="countries"
                            :hasValue="
                                user.home_country ? user.home_country : false
                            "
                            :setCountry="setBillingCountry"
                            :getIsoCodeFromName="getIsoCodeFromName"
                            :label="'home_country'"
                            :handler="countryHandler"
                        >
                            <template slot-scope="{ slotKey }">
                                <span
                                    :data-key="slotKey"
                                    :class="`iti-flag ${slotKey.toLowerCase()}`"
                                ></span>&nbsp;
                            </template>
                        </CountrySelect>
                        <InlineError
                            :errors="errors"
                            type="home_country"
                        />
                    </div>
                    <div
                        class="col-md-6 loader loader--inline"
                        v-else
                    >
                        <loader />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }"
                >
                    <div class="col-md-3">
                        <label
                            for="home_house_number"
                            v-translate
                        >House Number</label>
                    </div>
                    <div class="col-md-6">
                        <Input
                            id="home_house_number"
                            name="home_house_number"
                            :rule="{
                                rules: {
                                    required: user.home_house_number
                                        ? false
                                        : true
                                }
                            }"
                            model="user.home_house_number"
                            module="Enrolment"
                            :maxlength="100"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }"
                >
                    <div class="col-md-3">
                        <label
                            for="street_address"
                            v-translate
                        >Street Address</label>
                    </div>
                    <div class="col-md-6">
                        <AutoCompleteInput
                            id="home_street"
                            name="home_street"
                            model="user.home_street"
                            module="Enrolment"
                            :autocompleteOptions="predictions"
                            :emulatePlaceChange="emulatePlaceChange"
                            :changeHandler="callAutoComplete"
                        />
                    </div>
                </div>
                <div
                class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }"
                v-show="showState"
                >
                    <label
                        for="state"
                        class="col-md-3"
                        v-show="!showCounty"
                        v-translate
                    >State</label>
                    <label
                        for="state"
                        class="col-md-3"
                        v-show="showCounty"
                        v-translate
                    >County</label>

                    <div class="col-md-6">
                        <Input
                            :rule="showState ? 'required' : ''"
                            validateAs="state"
                            id="state"
                            name="home_state"
                            errorType="home_state"
                            model="user.home_state"
                            module="Enrolment"
                            :required="showState"
                            :lazy="false"
                            :maxlength="80"
                        />
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }">
                    <label
                        for="city"
                        class="col-md-3"
                        v-translate
                    >City</label>

                    <div class="col-md-6">
                        <Input
                            :rule="'required'"
                            validateAs="city"
                            id="city"
                            name="home_city"
                            errorType="home_city"
                            model="user.home_city"
                            module="Enrolment"
                            :required="true"
                            :lazy="false"
                            :maxlength="40"
                        />
                    </div>
                </div>
                <div class="form-group justify-content-center align-items-start"
                    :class="{ 'form-row': formRow, 'row': !formRow }">
                    <label
                        for="postcode"
                        class="col-md-3"
                        v-show="showPostcode"
                        v-translate
                    >Postcode</label>
                    <label
                        for="postcode"
                        class="col-md-3"
                        v-show="!showPostcode"
                        v-translate
                    >Zipcode</label>

                    <div class="col-md-6">
                        <Input
                            :rule="'required'"
                            validateAs="postcode"
                            id="postcode"
                            name="home_postcode"
                            errorType="home_postcode"
                            model="user.home_postcode"
                            module="Enrolment"
                            :required="true"
                            :lazy="false"
                            :maxlength="20"
                        />
                    </div>
                </div>

                <div
                    class="form-group row justify-content-center align-items-start"
                    v-if="!isSmartCharts"
                >
                    <p
                        class="text-standard"
                        v-translate
                    >This will reset your SmartCharts account password at the same time.</p>
                </div>
                <h3
                    class="text-center mb-4"
                    v-translate
                    >
                    Set Password
                </h3>
                <PasswordHandler :reset="false"/>
                <!-- <div class="form-group row justify-content-center mt-4 mb-0">
                    <div class="col-md-6 text-center">
                        <LoaderedButton
                            type="submit"
                            btnClasses="btn btn-primary btn--2x"
                            :content="'Confirm and Login' | translate"
                            :isValid="isValid"
                        />
                    </div>
                </div> -->
            </form>
        </template>
        <template slot='card-footer'>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
                <div class="col-sm-auto ml-auto mt-2 mt-sm-0">
                    <LoaderedButton
                        :clickHandler="submitForm"
                        btnClasses="btn btn-primary btn-full"
                        :content="'Confirm and Login' | translate"
                        :isValid="isValid"
                    />
                </div>
            </div>

        </template>
    </Card>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import FlashMessage from '@C/FlashMessage';
import Card from '@C/Card.vue';
import PasswordHandler from '@C/PasswordHandler';
import LoaderedButton from '@C/LoaderedButton';
import Input from "@C/Forms/Input";
import InlineError from "@C/Forms/InlineError";
import CountrySelect from "@C/CountrySelect";
import AutoCompleteInput from "@C/AutoCompleteInput";
import autocomplete from "@M/autocomplete";
import salutations from '@M/titleField';
import DOBPicker from '@C/DOBPicker';
import dob from '@M/dob';
import { twoDigits, getDaysInMonth } from '@H/enrolment';

import validator from '@M/validationWrapper';

export default {
    name: 'PasswordSet',
    props: {
        formRow: {
            type: Boolean,
            default: false
        },
    },
    beforeMount() {
        // Store the querystring email address into the vuex state
        this.$store.commit(
            'Auth/email',
            decodeURIComponent(this.$route.query.email)
        );
        //set user so we can use it on updating address and password
        this.$store.commit(
                'Enrolment/setUser',
                JSON.parse(window.localStorage.getItem('sfData'))
        );
    },
    created() {
        this.getOrganisedCountries();
    },
    computed: {
        isSmartCharts: function () {
            return window.isSmartCharts;
        },
        ...mapState('Flash', ['flash']),
        ...mapState('Enrolment', ['user']),
        ...mapState({
            billing_first_name: state => state.Enrolment.user.billing_first_name,
            billing_last_name: state => state.Enrolment.user.billing_last_name,
            billing_country: state => state.Enrolment.user.billing_country,
        }),
        ...mapState(["countries"]),
        showPostcode: function () {
            return (
                this.user.home_country == 'United Kingdom' ||
                typeof this.user.home_country == 'undefined'
            );
        },
        showState: function () {
            return (
                this.user.home_country == 'United States' ||
                this.user.home_country == 'United Kingdom'
            );
        },
        showCounty() {
            return this.user.home_country == 'United Kingdom';
        }
    },
    methods: {
        ...mapActions('Auth', ['passwordSet']),
        ...mapActions(['getOrganisedCountries']),
        ...mapMutations('Enrolment', [
            'setBillingCountry',
            'setDateOfBirth',
            'setHomeCountry'
        ]),
        formHandler() {
            this.setDateOfBirth(this.formattedDob);
            this.passwordSet().catch(this.handleOuterErrors);
        },
        countryHandler(e, firstRun = false) {
            let val = e.value || e.target.value;
            this.getIsoCodeFromName(val, this.countries);
            this.setBillingCountry(val);
            this.setHomeCountry(val);

            if (!firstRun) {
                this.resetCheckbox();
                this.resetBillingFields();
                this.$nextTick(() => {
                    this.validate();
                });
            }
        },
        submitForm() {
            this.$refs.form.dispatchEvent(new Event('submit', { cancelable: true }));
        },
        dobHandler(e) {
            let el = e.target || e;
            let key = this.stripDob(el.name);
            let val;
            if (key === 'month') {
                val = twoDigits(
                    this.months.indexOf(e.value || e.target.value) + 1
                );
            } else {
                val = e.value || e.target.value;
            }
            this[key] = val;

            const days = getDaysInMonth(this.month, this.year);

            this.$set(this.$data, 'days', days);
        },
        stripDob(str) {
            return str.split('-')[1];
        }
    },
    components: {
        Card,
        PasswordHandler,
        FlashMessage,
        LoaderedButton,
        CountrySelect,
        Input,
        InlineError,
        AutoCompleteInput,
        DOBPicker
    },
    mixins: [validator,  autocomplete("Enrolment"), salutations, dob]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/PasswordSet.vue